<template>
  <div id="app" data-v-app>
    <!-- <van-nav-bar title="" left-text="" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="Gray" size="18" />
      </template>
    </van-nav-bar> -->
    <!-- <van-notice-bar left-icon="volume-o" text="好消息！好消息！今天山东公众号H5版静态页面开发完成。并陆续转换成动态效果,目前注册功能可以使用.." /> -->
    <br />
    <h3 class="demo-home__title" style="margin: 16px">
      <img src="https://img.yzcdn.cn/vant/logo.png" />
      <!-- <span>山东智慧校园</span> -->
      <!-- <span>天津智慧校园</span> -->
      <span>AI智慧校园系统</span>
    </h3>
    <br />
    <!-- <div class="van-doc-demo-block__card" style="margin: 16px">
        <van-cell is-link :title="title" @click="show = true" />
        <van-action-sheet v-model="show" title="选择你的校区" :actions="actions" @select="onSelect"></van-action-sheet>
      </div> -->
    <div class="van-doc-demo-block" style="margin: 16px">
      <van-field
        readonly
        clickable
        name="xiaoqu"
        :value="xiaoqu"
        label="选择学校"
        placeholder="选择学校"
        @click="show = true"
        style="margin-top: 20px"
      />
      <van-popup v-model="show" position="bottom">
        <van-picker
          show-toolbar
          :columns="actions"
          value-key="schoolName"
          @confirm="onConfirm1"
          @cancel="show = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="titlesf"
        :value="titlesf"
        label="选择身份"
        placeholder="选择身份"
        @click="showsf = true"
        style="margin-top: 20px"
      />
      <van-popup v-model="showsf" position="bottom">
        <van-picker
          show-toolbar
          :columns="actionsf"
          value-key="name"
          @confirm="onConfirm2"
          @cancel="showsf = false"
        />
      </van-popup>
      <!-- <div class="van-doc-demo-block__card" style="margin: 16px">
        <van-cell is-link :title="title" @click="show = true" />
        <van-action-sheet
          v-model="show"
          title="选择你的学校"
          :actions="actions"
          @select="onSelect"
        ></van-action-sheet>
      </div>
      <div class="van-doc-demo-block__card" style="margin: 16px">
        <van-cell is-link :title="titlesf" @click="showsf = true" />
        <van-action-sheet
          v-model="showsf"
          title="选择身份"
          :actions="actionsf"
          @select="onSelectsf"
        ></van-action-sheet>
      </div> -->
      <div class="van-doc-demo-block" style="margin: 16px">
        <van-button id="buttontype" round block type="primary" :to="url">
          下一步
        </van-button>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
export default {
  data() {
    return {
      showsf: false,
      show: false,
      titlesf: "请选择登录身份",
      title: "请选择学校",
      url: "",
      openid: "",
      code: "",
      xiaoqu: "",
      xiaoquid: "",
      actionsf: [
        {
          name: "老师",
        },
        {
          name: "家长",
        },
        {
          name: "学生",
        },
      ],
      actions: [],
    };
  },
  created() {
    this.openid = this.$route.query.openid;
    this.onload();
    //添加学校数据操作以下
  },
  methods: {
    onload() {
      var params_json = {
        userid: "",
        action: "schoolList",
        param1: "",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
      };
      // console.log(params_json);
      this.$http.post("/web/list", params_json).then(function (res) {
        console.log(res.data["rows"]);
        this.actions = res.data["rows"];
      });
    },
    onConfirm1(value) {
      console.log(value.schoolName);
      this.xiaoqu = value.schoolName;
      this.xiaoquid = value.schoolId;
      this.show = false;
    },
    onConfirm2(value) {
      this.showsf = false;
      this.titlesf = value.name;
      this.jupLogin(this.titlesf);
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.title = item.name;
      this.xiaoquid = item.schoolId;
      this.xiaoqu = item.schoolName;
    },
    onSelectsf(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起

      this.showsf = false;
      this.titlesf = item.name;
      this.jupLogin(this.titlesf);
    },
    jupLogin() {
      if (this.titlesf == "请选择登录身份") {
        this.$notify({
          type: "danger",
          message: "请选择登录身份",
        });
      } else {
        this.code = this.$route.query.code;
        this.openid = this.$route.query.openid;
        console.log("code:" + this.code);
        console.log("openid:" + this.openid);
        if (this.titlesf == "家长") {
          this.url = {
            path: "Parent",
            query: {
              shenfen: this.titlesf,
              xiaoqu: this.xiaoqu,
              xiaoquid: this.xiaoquid,
              code: this.code,
              openid: this.openid,
            },
          };
        }
        if (this.titlesf == "老师") {
          this.url = {
            path: "Teacher",
            query: {
              shenfen: this.titlesf,
              xiaoqu: this.xiaoqu,
              xiaoquid: this.xiaoquid,
              code: this.code,
              openid: this.openid,
            },
          };
        }
        if (this.titlesf == "学生") {
          this.url = {
            path: "Student",
            query: {
              shenfen: this.titlesf,
              xiaoqu: this.xiaoqu,
              xiaoquid: this.xiaoquid,
              code: this.code,
              openid: this.openid,
            },
          };
        }
      }
    },
    onClickLeft() {
      // 成功通知
      this.$router.push("Login");
      // Notify({type:"success",message:"后退"});
    },
  },
};
</script>